import React, { Component, createRef } from 'react';
import { message, Pagination, Modal } from 'antd';
import { showNumber, statusIndexToText, statusTextToIndex, statusToButtons } from '../statusConfig';
import { SearchForm } from '../component/searchForm';
import LogisticsModal from '../component/LogisticsModal';
import { Message } from '../component/message';
import RenderList from '../component/renderList';
import CancelOrderModal from '../component/CancelOrder';
import CpEmpty from '../../../components/CpEmpty';
import ReceiveModal from '../component/receiveModal';
import { sendMessageApi, purchaseGoodsLogistics, orderPurchaseAgainOrder } from '../api';
import send from '../../../util/request';
import { downLoad } from '../../../util/tool';
import { ROOT_PATH } from '../../../origin';
import { queryString } from '../../../util/qs';
import moment from 'moment';
import '../style.less';

class OrderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderList: [],
      formateList: [],
      currentStatus: undefined,
      emptyStatus: '',
      loading: true,
      paginationProps: {
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: (current, pageSize) => this.pageChanged(current, pageSize)
      },
      messageInfo: {
        visible: false,
      },
      logisticsVisible: false,//物流详情弹框
      orderStatus: undefined,//订单编号
      logisticsData: [],//物流数据
      cancelOrderInfo: undefined,
      currentItem: undefined,
    };
    this.searchRef = createRef();
    this.receiveModalRef = createRef();
  }

  componentDidMount() {
    // let paramStr = sessionStorage.getItem('orderlist');
    // let params = {};
    // if (!paramStr || !paramStr.length) {
    //   params = { page: 1, page_size: 10, status: undefined };
    // } else {
    //   params = JSON.parse(paramStr);
    // }
    const search = new URLSearchParams(this.props.location.search);
    const order_no = search.get('order_no');
    const params = { page: 1, page_size: 10, status: undefined };
    if (order_no) {
      this.searchRef.form.setFieldsValue({ order_no });
    }
    this.requestOrderList(params);
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  searchFn = () => {
    const { paginationProps: { pageSize } } = this.state;
    this.requestOrderList({ page: 1, page_size: pageSize, status: undefined });
  }
  exportFn = () => {
    const { paginationProps: { pageSize } } = this.state;
    this.requestOrderList({ page: 1, page_size: pageSize, status: undefined }, true);
  }

  requestOrderList = (params = {}, isExport = false) => {
    const { dateRange = [], ...formValues } = this.searchRef?.form?.getFieldsValue() || {};
    const { order_status } = formValues;
    const newFormValues = +order_status === 10 ? { ...formValues, order_status: '' } : formValues;
    let { page: current = 1, page_size: pageSize = 10, status: currentStatus = undefined } = params;
    const [start_time, end_time] = dateRange.map(item => moment(item).format('YYYY-MM-DD'));
    if (isExport) {
      downLoad({
        url: `${ROOT_PATH}/ipp/order-purchase/select?${queryString({
          start_time,
          end_time,
          ...params,
          ...newFormValues,
          export: 1,
          token: localStorage.getItem('token')
        })}`,
        name: `订单数据-${moment(new Date()).format('YYYY-MM-DD')}.xlsx`
      });
      return;
    }
    this.setState({
      currentStatus,
      activeStatus: statusIndexToText[currentStatus],
      paginationProps: { ...this.state.paginationProps, current, pageSize }
    });
    send({
      url: '/ipp/order-purchase/select',
      method: 'GET',
      params: { start_time, end_time, ...params, ...newFormValues },
      options: { loading: true }
    }).then(res => {
      const { data, data: { code } } = res;
      if (data && code === 0) {
        let { list = [], page, total } = data.data;
        let array = [];
        const orderList = list.map(item => {
          const { create_time, order_no, id, supplier_name, real_price, expected_date, order_desc, order_status, purchase_id, purchase_name, supplier_id, delivery_type, productInfo = [], is_information } = item;
          const total = productInfo.reduce((acc, cur) => Number(acc) + Number(cur.number), 0) || [];
          const saleList = productInfo.map(item => ({ ...item, supplier_id }));
          // const buttonsConfirmedStatus = receiveInfo?.length ? 100 : 0;

          return {
            ...item,
            createTime: create_time,
            orderNo: order_no,
            orderId: id,
            supplier: supplier_name,
            realPrice: real_price,
            orderStatus: +order_status,
            statusText: statusIndexToText['' + order_status],
            buttonText: [15, 20].includes(+order_status) && statusToButtons['' + order_status],
            // buttonConfirmed: (+order_status === 30) && statusToButtonsConfirmed[buttonsConfirmedStatus],
            purchaseId: purchase_id, // 客户ID
            supplierId: supplier_id, //  商户ID
            orderDesc: order_desc,
            purchaseName: purchase_name,
            deliveryType: delivery_type,//物流方式 3tms
            expectedDate: expected_date,
            isInformation: is_information,
            total,
            saleList,
            isExpand: saleList.length > showNumber,
            showCancelModal: true
          };
        }) || [];

        this.setState({
          paginationProps: { ...this.state.paginationProps, current: Number(page), total: Number(total) },
          orderList,
          emptyStatus: (array.length <= 0 && params.status === undefined) ? 'order' : '',
          loading: false
        });
        // sessionStorage.setItem('orderlist', JSON.stringify(params));
      } else {
        message.error(res.data.msg);
      }
    });
  }

  toOrderDetail = (item, report = 0) => {
    this.props.history.push('/basic/user/order/detail/' + item.orderNo + '/' + report);
  }

  stateChanged = (e) => {
    const { key } = e;
    let status = statusTextToIndex[key];
    this.setState({
      activeStatus: key,
      currentStatus: status
    });

    let { current, pageSize } = this.state.paginationProps;
    this.requestOrderList({ page: current, page_size: pageSize, status });
  }
  getFormValues = (values) => {
    this.btnClicked({ ...this.state.cancelOrderInfo, ...values });
  }
  cancelOrderFu = () => {
    this.setState({ cancelOrderInfo: undefined });
  }
  cancelOrder = (item) => {
    this.setState({ cancelOrderInfo: item });
  }
  btnClicked = (item) => {
    const { buttonText, orderNo, orderStatus, receive_info, cancel_desc, is_manual } = item;
    const status = orderStatus === 30 ? 40 : 50;
    send({
      url: '/ipp/order-purchase/status',
      method: 'POST',
      data: {
        id: orderNo,
        status,
        receive_info,
        cancel_desc,
        is_manual
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(buttonText + '成功', () => {
          this.receiveModalRef.current && this.receiveModalRef.current.setBillOpen && this.receiveModalRef.current.setBillOpen(true);
        });
        this.setState({ cancelOrderInfo: undefined, showBillModal: true });
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
      } else {
        message.error(res.data.msg);
      }
    });
  }

  changeStatus = async (item) => {
    const { receiveInfo = [], orderNo: order_no, orderNo, orderStatus } = item;
    if (receiveInfo.length) {
      const { data: { msg, code } } = await send({ url: '/ipp/order-purchase/finish', method: 'POST', data: { order_no } });
      if (+code === 0) {
        message.success(msg);
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
      } else {
        message.error(msg);
      }
    } else {
      // this.btnClicked(item);
      const status = orderStatus === 30 ? 40 : 50;
      send({
        url: '/ipp/order-purchase/status',
        method: 'POST',
        data: {
          id: orderNo,
          status
        }
      }).then(res => {
        if (res.data && res.data.code === 0) {
          const title = `确定${item.orderStatus === 20 ? '取消' : `${item.receiveInfo.length ? '完结订单' : '收货'}`}`;
          message.success(title + '成功');
          const { currentStatus, paginationProps: { current, pageSize } } = this.state;
          this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
        } else {
          message.error(res.data.msg);
        }
      });
    }
  }

  handleCancel = () => {
    this.setState({
      modalVisible: false
    });
  }

  handleOk = () => {
    const { currentOrder } = this.state;
    const { orderNo, orderStatus, buttonText } = currentOrder;
    const status = orderStatus === 30 ? 40 : 50;

    this.setState({
      modalVisible: false
    });

    send({
      url: '/ipp/order-purchase/status',
      method: 'POST',
      data: {
        id: orderNo,
        status
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(buttonText + '成功');
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
      } else {
        message.error(res.data.msg);
      }
    });
  }

  pageChanged = (page, pageSize) => {
    let { currentStatus } = this.state;
    this.requestOrderList({ page, page_size: pageSize, status: currentStatus });
  }

  toProductDetail = (product) => {
    const { supplier_id, sale_id, norms_id } = product;

    if (!norms_id || !supplier_id || !sale_id) {
      message.info('商品缺少spu_id或sale_id或supplier_id');
      return;
    }

    this.props.history.push('/basic/product/detail/' + sale_id + '/' + supplier_id + '/' + norms_id);
  }

  onHandlerSpot = (item) => {
    send({
      url: '/ipp/message/info',
      method: 'GET',
      params: {
        order_no: item.orderNo,
        buyer_id: item.purchaseId,
        supplier_id: item.supplierId,
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        // 重新拉取列表
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });

        const { messageInfo } = this.state;

        let info = res.data.data;
        if (!info.msg_list) {
          info.msg_list = [];
        }
        let msgList = info.msg_list.map(item => ({
          buyerId: item.buyer_id,
          createTime: item.create_time,
          msgInfo: item.msg_info,
          role: item.role,
          supplierId: item.supplier_id
        }));
        info.msg_list = msgList;
        this.setState({
          messageInfo: {
            ...messageInfo,
            visible: true,
            ...info,
            title: item.supplier,
            list: info.msg_list,
            orderNo: item.orderNo,
            record: item
          },
        }, () => {
          const content = document.getElementsByClassName('message_scroll_content')[0];
          const scrollOffset = content.offsetHeight;
          const scrollOffsetHeight = content.scrollHeight;
          const diff = scrollOffsetHeight - scrollOffset;
          content.scrollTop = diff;
        });
      } else {
        message.error(res.data.msg);
      }
    });
  }

  getOrderDetail = () => {

  }

  expandFn = (item) => {
    const { isExpand, orderNo } = item;
    const { orderList = [] } = this.state;
    const newOrderList = orderList.map(item => orderNo === item.orderNo ? { ...item, isExpand: !isExpand } : item);
    this.setState({ orderList: newOrderList });
  }

  onHandlerSend = async (msgInfo, record) => {
    if (!msgInfo) {
      return message.info('发送信息不能为空');
    }
    let sendMsg = msgInfo.trim();
    if (sendMsg === '') {
      return message.info('发送信息不能为空');
    }
    const data = {
      orderNo: record.orderNo,
      buyerId: record.purchaseId,
      buyerName: record.purchaseName,
      supplierId: record.supplierId,
      supplierName: record.supplier,
      msgInfo
    };
    const { data: { code, msg } } = await sendMessageApi(data);
    if (code !== 0) {
      return message.error(msg);
    }
    if (code === 0) {
      this.onHandlerSpot(record);
    }
  }

  onHandlerClose = () => {
    this.setState({
      messageInfo: {
        visible: false,
      }
    });
  }

  handleLogistics = (item) => {
    this.setState({
      logisticsVisible: true,
      orderStatus: item.status
    }, () => {
      this.getLogistics(item);
    });
  }

  getLogistics = (item) => {
    purchaseGoodsLogistics({ order_no: item.orderNo, supplier_id: item.supplierId }).then(res => {
      if (res.data && res.data.code === 0) {
        const { data } = res.data;
        this.setState({
          logisticsData: data.length ? data : []
        });
      }
    });
  }

  handleLogCancel = () => {
    this.setState({
      logisticsVisible: false
    });
  }

  perfectInformation = (item) => {
    this.props.history.push('/basic/user/order/information/' + item.orderNo);
  }

  toUserBill = (item) => {
    this.props.history.push(`/basic/user/bill?order_no=${item.orderNo}`);
  }

  orderPurchaseAgain = async (item) => {
    const { order_no } = item;
    const { data: { code, msg } } = await orderPurchaseAgainOrder({ order_no });
    if (+code === 0) {
      message.success(msg, this.props.history.push('/basic/shopCart'));
    } else {
      message.error(msg);
    }
  }

  setCurrentItem = (item) => {
    this.setState({
      currentItem: item
    });
  }
  render() {
    const { orderList, emptyStatus, loading, paginationProps, messageInfo } = this.state;
    const empty = (<div className="order-empty"><CpEmpty status={emptyStatus} history={this.props.history} /></div>);

    return (
      <div className="order-list">
        <div className="title">我的采购单</div>
        <div className="order-content">
          <SearchForm ref={el => this.searchRef = el} searchFn={this.searchFn} exportFn={this.exportFn} />
          {
            (orderList.length <= 0 && emptyStatus.length) ? empty : <RenderList
              formateList={orderList}
              btnClicked={this.btnClicked}
              changeStatus={this.changeStatus}
              toOrderDetail={this.toOrderDetail}
              toUserBill={this.toUserBill}
              // handleLogistics={this.handleLogistics}
              perfectInformation={this.perfectInformation}
              expandFn={this.expandFn}
              onHandlerSpot={this.onHandlerSpot}
              toProductDetail={this.toProductDetail}
              orderPurchaseAgain={this.orderPurchaseAgain}
              cancelOrder={this.cancelOrder}
              setCurrentItem={this.setCurrentItem}
            />
          }
          <Message
            {...messageInfo}
            onClick={this.onHandlerClose}
            send={this.onHandlerSend}
          />
        </div>
        {/* {orderList.length <= 0 && (<div className="status-empty-tip">当前状态下暂无订单~</div>)} */}
        <div className="pagination">
          {loading || (orderList.length <= 0 && emptyStatus.length) ? null : <Pagination {...paginationProps} />}
        </div>
        <Modal
          open={this.state.modalVisible}
          cancelText="取消"
          okText="确定"
          onOk={() => { this.handleOk(); }}
          onCancel={() => { this.handleCancel(); }}>
          {'是否' + this.state.modalContent + '?'}
        </Modal>
        <LogisticsModal
          open={this.state.logisticsVisible}
          oncancel={this.handleLogCancel}
          orderStatus={this.state.orderStatus}
          logisticsData={this.state.logisticsData}
        >
        </LogisticsModal>
        {this.state.cancelOrderInfo ? <CancelOrderModal getFormValues={this.getFormValues} cancelOrder={this.cancelOrderFu} /> : null}
        {this.state.currentItem ? <ReceiveModal ref={this.receiveModalRef} setCurrentItem={this.setCurrentItem} item={this.state.currentItem || {}} btnClicked={this.btnClicked} /> : null}
      </div>
    );
  }
}
export default OrderList;